
import BoxTime from "../../../assets/duotone/BoxTime.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BoxTimeIcon({ className, dataTestid = "BoxTimeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BoxTime data-testid={dataTestid} className={classes} {...rest} />
  );
}
